module.exports = __webpack_public_path__ + "static/media/P2-Plunger.46a47466.svg";